import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.span = this.$('span')[0];
    }

    init() {
        document.addEventListener("scroll", () => {
            let docHeight = window.scrollY / (document.documentElement.scrollHeight - document.documentElement.clientHeight) * 100;
            this.span.style.width = docHeight + '%';
        })
    }
}
